import { call, fork, put, take } from 'redux-saga/effects';

import { AUTHENTICATION_FINISHED } from '../../modals/addPaymentMethodModal/AddPaymentMethodModal.actions';
import { authenticationCompleteWorker } from '../../modals/addPaymentMethodModal/AddPaymentMethodModal.sagas';
import {
    SHOW_PROCESING_PAYMENT_MODAL_AUTHENTICATION_REQUIRED,
    SHOW_PROCESING_PAYMENT_MODAL_COMPLETED,
    SHOW_PROCESING_PAYMENT_MODAL_ERROR
} from '../../modals/processingPaymentModal/ProcessingPaymentModal.actions';

export function* confirmStripePaymentIntent(stripe, response) {
    const paymentIntentSecret = response?.data?.payment_intent?.secret;

    if (!paymentIntentSecret) {
        return yield put({
            type: SHOW_PROCESING_PAYMENT_MODAL_ERROR
        });
    }

    const { error, paymentIntent = {} } = yield call(() =>
        stripe.confirmPaymentIntent(paymentIntentSecret, {
            return_url:
                'https://pandora.iwoca.com/prod/uk/stripe/authentication_finished.html'
        })
    );

    if (paymentIntent.status) {
        yield handlePaymentIntentResponse(
            stripe,
            paymentIntent,
            paymentIntentSecret
        );
    } else {
        return yield put({
            type: SHOW_PROCESING_PAYMENT_MODAL_ERROR,
            extra: error
        });
    }
}
function* handlePaymentIntentResponse(
    stripe,
    paymentIntent,
    paymentIntentSecret
) {
    switch (paymentIntent.status) {
        case 'requires_confirmation':
            return yield handlePaymentConfirmation(stripe, paymentIntentSecret);
        case 'succeeded':
        case 'processing':
            return yield put({ type: SHOW_PROCESING_PAYMENT_MODAL_COMPLETED });
        case 'requires_source_action':
        case 'requires_action':
            yield handlePaymentAuthentication(
                stripe,
                paymentIntent,
                paymentIntentSecret
            );
    }
}

function* handlePaymentAuthentication(
    stripe,
    paymentIntent,
    paymentIntentSecret
) {
    yield put({
        type: SHOW_PROCESING_PAYMENT_MODAL_AUTHENTICATION_REQUIRED,
        authenticationIframeURL: paymentIntent.next_action.redirect_to_url.url
    });

    yield fork(authenticationCompleteWorker);

    yield take(AUTHENTICATION_FINISHED);

    const { error, paymentIntent: confirmedPaymentIntent } = yield call(() =>
        stripe.retrievePaymentIntent(paymentIntentSecret)
    );

    if (!error && confirmedPaymentIntent.status === 'succeeded') {
        return yield put({
            type: SHOW_PROCESING_PAYMENT_MODAL_COMPLETED
        });
    } else {
        return yield put({
            type: SHOW_PROCESING_PAYMENT_MODAL_ERROR,
            extra: error
        });
    }
}

function* handlePaymentConfirmation(stripe, paymentIntentSecret) {
    const result = yield call(() =>
        stripe.confirmCardPayment(paymentIntentSecret)
    );

    if (result.paymentIntent) {
        return yield put({ type: SHOW_PROCESING_PAYMENT_MODAL_COMPLETED });
    } else {
        return yield put({
            type: SHOW_PROCESING_PAYMENT_MODAL_ERROR,
            extra: result.error
        });
    }
}
